import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import EditForm from '../../../../../../features/components/Forms/EditForm'
import BehavioursSelect from '../../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields/AdvancedAudienceTargetingSection/BehavioursSelect'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'

import { formatBehaviorsToBE } from '../../../../formatters'

import { clearUpdateLineItem, updateLineItem } from '../../../../../../modules/actions/lineItems'
import {
  lineItemUpdateErrorSelector,
  lineItemUpdateIsLoadingSelector,
  lineItemWasUpdatedSelector
} from '../../../../../../modules/selectors/lineItems'
import { campaignSelector } from '../../../../../../modules/selectors/campaigns'
import { selectedFacebookAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { FACEBOOK_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'
import { BEHAVIORS } from '../../../../../ReusableFormFields/Audiences/FacebookAudienceFields/FacebookUploadCreativeAudienceFields/AdvancedAudienceTargetingSection/BehavioursSelect/fields'

const BehaviorsSectionForm = ({ editItemData: lineItem, title, ...formProps }) => {
  const dispatch = useDispatch()

  const lineItemWasUpdated = useSelector(lineItemWasUpdatedSelector)
  const selectedAdAccount = useSelector(selectedFacebookAdAccountSelector)
  const { objective: campaignObjective } = useSelector(campaignSelector)

  const { [BEHAVIORS]: lineItemBehaviors } = lineItem

  const handleSubmit = useCallback(
    values => {
      const updateLineItemData = {
        account: selectedAdAccount.id,
        campaign_objective: campaignObjective,
        [BEHAVIORS]: formatBehaviorsToBE(values[BEHAVIORS]),
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        }
      }

      dispatch(updateLineItem(updateLineItemData, lineItem.id, FACEBOOK_PLATFORM))
    },
    [dispatch, lineItem.id, campaignObjective, selectedAdAccount, title]
  )

  const initialValues = useMemo(() => {
    return {
      [BEHAVIORS]: lineItemBehaviors?.length
        ? lineItemBehaviors.map(behaviour => ({
            ...behaviour,
            value: behaviour.id,
            label: behaviour.name
          }))
        : []
    }
  }, [lineItemBehaviors])

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    onSubmit: handleSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const handleClearUpdateLineItem = useCallback(() => {
    dispatch(clearUpdateLineItem())
  }, [dispatch])

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={lineItemWasUpdated}
      clearEditItem={handleClearUpdateLineItem}
      errorSelector={lineItemUpdateErrorSelector}
      isLoadingSelector={lineItemUpdateIsLoadingSelector}
      {...formProps}
    >
      <BehavioursSelect formik={formik} />
    </EditForm>
  )
}

export default BehaviorsSectionForm
